import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../../graphql/auth';
import {gqlLoggedInUser, setMe} from '../../../graphql/auth/getMe';
import {onLoginComplete} from '../../LogIn/loginUser.api';
import {clearCache} from '../../../graphql/GraphQlProvider';

interface ImpersonateUserVars {
    id: number
}

interface ImpersonateUserData {
    impersonateUser: {
        access_token: string,
        user: User,
    }
}

export const IMPERSONATE_USER_MUTATION = gql`
    mutation impersonateUser($id: Int!) {
        impersonateUser(id: $id) {
            access_token
            user {
                ${gqlLoggedInUser}
            }
        }
    }
`;

export const impersonateUser = () => useMutation<ImpersonateUserData, ImpersonateUserVars>(
    IMPERSONATE_USER_MUTATION, {
        update: (proxy, response) => {
            clearCache(false);
            const me = response.data!.impersonateUser.user;
            setMe(proxy, me);
        },
        onCompleted: (response: ImpersonateUserData) => {
            if (response && response.impersonateUser) {
                onLoginComplete(response.impersonateUser.access_token)
            }
        }
    }
);

export default impersonateUser;
